export const BRIDGE_MESSAGE_TYPE = "iframeBridgeEvent";
export const EVENTS_TYPE = {
    DATA_LAYER: "dataLayer",
    LOADING_SCREEN_SHOW: "loadingScreenShow",
    LOADING_SCREEN_HIDE: "loadingScreenHide",
    PARENT_REDIRECT: "parentRedirect"
};
